import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PhproductformEditForm from './PhproductformEditForm';
import PhproductformList from './PhproductformList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PhproductformListView from './PhproductformListView'


export default function PhproductformDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.phproductformDashboard);
  const [ phproductformId, setPhproductformId] = React.useState('');
  const [reloadPhproductformList, setReloadPhproductformList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PhproductformEditForm 
            setReloadPhproductformList={setReloadPhproductformList}
            phproductformId={phproductformId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PhproductformListView 
                      setPhproductformId = {setPhproductformId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
